export const breakpoints = { // NOTE: This is originally from styles/_variables.scss
  // min, max
  all: ['0rem', false],
  tiny: [false, '29.999rem'],
  small: ['30rem', '47.999rem'],
  medium: ['48rem', '63.999rem'],
  large: ['64rem', '74.999rem'],
  huge: ['75rem', false]
}

// this is adapted from the scss @mixin respond-to, NOTE: May not work in all browsers!!  Do not use.
export function respondTo (breakpoint, type, callback) {
  let mq = getMediaQuery(breakpoint, type)
  if (!mq) return undefined

  let onChange = (mq) => {
    if (mq.matches) return callback()
  }

  mq.addListener(onChange)
  onChange(mq)
}

export function getMediaQuery (breakpoint, type) {
  // breakpoint: 'all|tiny|small|medium|large|huge'
  // type: 'min|max|both'

  if (breakpoint === 'all') type = 'both'

  if (!window.matchMedia) throw new Error('Unable to watch media changes in this browser, please update.')
  if (!breakpoint || typeof breakpoint.toLowerCase !== 'function' || !breakpoints[breakpoint.toLowerCase()]) {
    throw new Error(`No breakpoint found in getMediaQuery (${breakpoint}), please send a proper breakpoint!`)
  }

  breakpoint = breakpoint.toLowerCase()
  let array = breakpoints[breakpoint]
  let min = array[0]
  let max = array[1]
  let query = ''

  if (type === 'both' && min && max) {
    query = `(min-width: ${min}) and (max-width: ${max})`
  } else if (type === 'min' && min) {
    query = `(min-width: ${min})`
  } else if (type === 'max' && max) {
    query = `(max-width: ${max})`
  }

  if (!query) return
  return window.matchMedia(query)
}

export function mediaQueryMatches (breakpoint, type) {
  let mq = getMediaQuery(breakpoint, type)

  if (!mq) return undefined
  return !!mq.matches
}

export default mediaQueryMatches



// WEBPACK FOOTER //
// ./src/helpers/mediaQuery.js